import * as ActionTypes from '../actions/ActionTypes';
import DisabledInteractionsConfigRecord from '../records/DisabledInteractionsConfigRecord';
export default function disabledInteractionsConfig(state = new DisabledInteractionsConfigRecord(), action) {
  switch (action.type) {
    case ActionTypes.FETCH_DISABLED_INTERACTIONS_CONFIG_PENDING:
      return state.merge({
        isRequesting: true
      });
    case ActionTypes.FETCH_DISABLED_INTERACTIONS_CONFIG_SUCCESS:
      return new DisabledInteractionsConfigRecord(Object.assign({}, action.payload, {
        lastLoaded: Date.now()
      }));
    case ActionTypes.FETCH_DISABLED_INTERACTIONS_CONFIG_ERROR:
      return state.merge({
        isRequesting: false
      });
    default:
      return state;
  }
}